import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ListItems from "./components/ListItems";
import WhoAmI from "./components/WhoAmI";
import Footer from "./components/Footer";
import Callouts from "./components/Callouts";
import {
  Typography,
  Container,
  Box,
  Card,
  CardMedia,
  Stack,
} from "@mui/material";

import VideoPlayer from "./components/VideoPlayer";
import links from "./assets/links.json";
import Logo from "./components/Logo";

const Home = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "transparent" }}>
        {/* Hero + logo column (narrow, centred) */}
        <Container
          maxWidth="sm"
          sx={{
            pb: { xs: 4, md: 6 },
            pt: { xs: 2, sm: 3, md: 5 },
            position: "relative",
            overflow: "visible",
          }}
        >
          <Logo />

          {/* Titles */}
          <Box sx={{ textAlign: "center", mb: { xs: 2.5, md: 3 } }}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: "26.25rem",
                mx: "auto",
                fontSize: "clamp(0.95rem, 2.2vw, 1.05rem)",
                lineHeight: 1.6,
                px: { xs: 2, sm: 0 },
              }}
            >
              Specialising in Science Communication, Liaison and Strategic
              Directions
            </Typography>
          </Box>

          {/* Dark pill callouts */}
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Callouts />
          </Box>

          {/* Portrait image */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              position: "relative",
              zIndex: 1,
              px: { xs: 2, sm: 0 },
            }}
          >
            <Card
              elevation={0}
              sx={{
                maxWidth: "min(90vw, 30rem)",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <CardMedia
                component="img"
                image={"ME.png"}
                // image={'ME2.png'}
                alt="Portrait"
                sx={{
                  width: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
                draggable={false}
              />
            </Card>
          </Box>
        </Container>

        {/* Consultancy section – wider with two columns */}
        {/* No extra flex container so ListItems can center its own content */}
        <ListItems />

        <VideoPlayer videos={Object.values(links)}  />


        {/* Who am I? – full width black band */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <WhoAmI />
        </Box>
      </Box>
    </>
  );
};

const App = () => {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#ffffff" }}>
      {/* Top navigation – light, centred */}

      <Box
        sx={{ display: "flex", justifyContent: "center", height: "45px" }}
      ></Box>

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<AboutLouiseSerpell2 />} /> */}
        {/* <Route path="/about2" element={<AboutLouiseSerpell2 />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </Box>
  );
};

export default App;
